<template>
  <div id="medlemsfordele" class="animated fadeIn pt2 pb4">
    <!-- desktop view -->
    <div class="flex flex-wrap justify-start gibson mt2 pl4 mb2" v-if="!showMobile">
      <div class="col-6">
        <div class="col-12 pt0">
          <button @click="recommend()" class="action-button p2 gibson h5 regular line-height-1 flex justify-start items-center" >
            <span>Anbefal os og få et tivolikort</span>
            <span class="ml2"><i class="el-icon-right"></i></span>
          </button>
        </div>
        <div class="col-12 pt3 pb3">
          <p class="h4 darkblue gibson semi-bold">
            Medlemsfordele
          </p>
          <p class="h5 darkblue regular line-height-3 my2">
            Som medlem hos håndværker.dk har du flere fordele du kan benytte dig af. Se samarbejdspartnere og fordele herunder.
          </p>
        </div>
      </div>
      <div class="col-12" v-if="insideLoading">
        <div class="clearfix">
          <div class="loader"></div>
        </div>
      </div>
      <div class="clearfix px2" v-else>
        <div class="col-6 pb2" v-if="formLegalTopicVisible">
          <div class="col-12 px0 py2">
            <span class="h5 darkblue mb2">Gratis juridisk hjælpelinje</span>
            <p class="darkblue mb2">Som loyalt medlem hos Håndværker.dk har du adgang til en gratis juridisk hjælpelinje. Her kan du få hjælp til entrepriseretlige spørgsmål. Rådgivningen foregår på mail og varetages af Hasløv Stæhr Advokater.</p>
            <div class="mb2"></div>
            <div class="clearfix" v-if="hotlineLoading">
              <div class="col-12">
                <div class="loader"></div>
              </div>
            </div>
            <div v-else>
              <!-- <select v-model="legalTopic" class="col-12 custom-select mb2" multiple>
                <option :value="null" disabled>Vælg en indstilling</option>
                <option :value="topic.NAME" v-for="(topic,index) in legalTopicData" :key="index">{{topic.NAME}}</option>
              </select> -->
              <el-select v-model="legalTopic" placeholder="Vælg en indstilling" class="col-12 p0 mb2" multiple>
                <el-option v-for="(topic,index) in legalTopicData" :label="topic.NAME" :value="topic.NAME" :key="index">
                </el-option>
              </el-select>
              <p class="darkblue mb1">Uddyb venligst behov</p>
              <b-form-input v-model="note" class="mb2"></b-form-input>
              <p class="darkblue mb1">Vedhæft relevante dokumenter</p>
              <file-upload-input token="" module="" @UpdateTilbud="handleFileUpload"></file-upload-input>
              <div class="flex justify-start items-center">
                <b-button type="button" class="action-button py2 px3 m0 line-height-1 gibson not-rounded border-none regular mr2" @click="submitLegalHotline()">Send</b-button>
                <p class="darkblue line-height-1 my0 ml2">Du bliver ringet op af Hasløv Stæhr Advokater, når de har set på din sag.</p>
              </div>
            </div>
          </div>
        </div>
        <div v-for="item in medlemsfordele" :key="item.ID" class="pb4">
          <div class="border-none shadow col-12 p2">
            <div class="col-12 px0 flex justify-start items-start">
              <div class="px2 mb2">
                <div class="col-4 px0 mt2">
                  <img :src="item.PROPERTY_IMAGE_URL_VALUE" width="120" alt="">
                </div>
                <p class="h6 darkblue regular line-height-3 my2" v-if="item.NAME === 'Dinero'">
                  Som medlem hos Håndværker.dk kan du få et fremragende tilbud fra Dinero.* Du skal blot udfylde navn og e-mail på linket herunder. Dinero vil derefter kontakte dig og hjælpe dig med den rigtige løsning til dig. Fortæl, at du er medlem hos Håndværker.dk. *Tilbuddet gælder nye Dinero-brugere.
                </p>
                <p v-html="item.PROPERTY_DESCRIPTION_VALUE.TEXT" class="h6 darkblue regular line-height-3 my2" v-else></p>
                <template>
                  <div v-if="item.PROPERTY_CODE_VALUE !== null " class="flex justify-between items-center">
                    <p class="h6 darkblue regular line-height-golden">Rabatkode : <span class="secondarycolor">{{item.PROPERTY_CODE_VALUE}}</span>
                    </p>
                    <input type="hidden" id="couponCode" :value="couponCode">
                    <button type="button" @click.stop.prevent="copyCouponCode" class="standard-button h6 regular p2 flex justify-center items-center gibson line-height-1 not-rounded border-none">
                      <span>Kopier kode</span>
                      <span class="ml1"><i class="el-icon-copy-document"></i></span>
                    </button>
                  </div>
                  <div v-else-if="item.PROPERTY_CONTACT_MEMBERS_CODE_VALUE === 'flugger101' ">
                    <div class="">
                      <p class="darkblue h3" >Kontakt</p>
                      <a style="float: right; "  :href="'skype:'+item.PROPERTY_CONTACT_PHONE_VALUE+'?call'" ><i class="green el-icon-phone-outline" style="font-size: 2em;"></i></a>
                    </div>
                    <div class="flex px0 mt2"> <img :src="item.PROPERTY_CONTACT_PHOTO_VALUE" width="100" alt=""> 
                      <div class="" >
                        <p class="darkblue h6 regular pl2" >{{ item.PROPERTY_CONTACT_NAME_VALUE }}</p>
                        <p class="darkblue h6 regular pl2" >Tel: {{ item.PROPERTY_CONTACT_PHONE_VALUE }}</p>
                        <p class="darkblue h6 regular pl2" >{{ item.PROPERTY_CONTACT_EMAIL_VALUE }}</p>
                      </div>
                    </div>
                  </div>
                  <div v-else></div>
                </template>
                <a  :href="item.PROPERTY_LINK_VALUE" target="_blank" class="inline-block action-button p2 h6 regular m0 line-height-1 gibson not-rounded border-none white" v-if="item.PROPERTY_CONTACT_MEMBERS_CODE_VALUE !== 'flugger101' ">
                  <span v-html="item.PROPERTY_BUTTON_VALUE" class="mr2 regular white"></span><span><i class="el-icon-right white"></i></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- mobile view -->
    <div class="flex flex-wrap justify-start gibson mt2" v-if="showMobile">
      <div class="col-12 pt0 pr3 pb0 pl3">
        <button @click="recommend()" class="action-button p2 gibson h5 regular line-height-1 flex justify-start items-center">
          <span>Anbefal os og få et tivolikort</span>
          <span class="ml2"><i class="el-icon-right"></i></span>
        </button>
        <div class="py1"></div>
        <p class="h4 darkblue gibson semi-bold mb2">
          Medlemsfordele
        </p>
        <p class="h5 darkblue gibson regular line-height-3 my2">
          Som medlem hos håndværker.dk har du flere fordele du kan benytte dig af. Se samarbejdspartnere og fordele herunder.
        </p>
      </div>
      <div class="col-12" v-if="insideLoading">
        <div class="clearfix">
          <div class="loader"></div>
        </div>
      </div>
      <div class="col-12 p3" v-else>
        <div class="col-12 p0 pb2" v-if="formLegalTopicVisible">
          <div class="border-none shadow col-12 p2">
            <span class="h5 darkblue mb2">Gratis juridisk hjælpelinje</span>
            <p class="darkblue mb2">Som loyalt medlem hos Håndværker.dk har du adgang til en gratis juridisk hjælpelinje. Her kan du få hjælp til entrepriseretlige spørgsmål. Rådgivningen foregår på mail og varetages af Hasløv Stæhr Advokater.</p>
            <div class="mb2"></div>
            <div class="clearfix" v-if="hotlineLoading">
              <div class="col-12">
                <div class="loader"></div>
              </div>
            </div>
            <div v-else>
              <!-- <select v-model="legalTopic" class="col-12 custom-select mb2" multiple>
                <option :value="null" disabled>Vælg en indstilling</option>
                <option :value="topic.NAME" v-for="(topic,index) in legalTopicData" :key="index">{{topic.NAME}}</option>
              </select> -->
              <el-select v-model="legalTopic" placeholder="Vælg en indstilling" class="col-12 p0 mb2" multiple>
                <el-option v-for="(topic,index) in legalTopicData" :label="topic.NAME" :value="topic.NAME" :key="index">
                </el-option>
              </el-select>
              <p class="darkblue mb1">Uddyb venligst behov</p>
              <b-form-input v-model="note" class="mb2"></b-form-input>
              <p class="darkblue mb1">Vedhæft relevante dokumenter</p>
              <file-upload-input token="" module="" @UpdateTilbud="handleFileUpload"></file-upload-input>
              <div>
                <b-button type="button" class="action-button py2 px3 m0 line-height-1 gibson not-rounded border-none regular col-12 p0 mb2" @click="submitLegalHotline()">Send</b-button>
                <p class="darkblue m0">Du bliver ringet op af Hasløv Stæhr Advokater, når de har set på din sag.</p>
              </div>
            </div>
          </div>
        </div>
        <!-- ageras -->
        <div v-for="item in medlemsfordele" :key="item.ID" class="border-none shadow col-12 p3 pt2 flex flex-column">
          <div>
            <div class="py2"></div>
            <img :src="item.PROPERTY_IMAGE_URL_VALUE" width="120" alt="">
          </div>
          <div class="my2">
            <p class="h5 darkblue regular line-height-golden" v-if="item.NAME === 'Dinero'">
              Som medlem hos Håndværker.dk kan du få et fremragende tilbud fra Dinero.* Du skal blot udfylde navn og e-mail på linket herunder. Dinero vil derefter kontakte dig og hjælpe dig med den rigtige løsning til dig. 
Fortæl, at du er medlem hos Håndværker.dk. *Tilbuddet gælder nye Dinero-brugere.
            </p>
            <p v-html="item.PROPERTY_DESCRIPTION_VALUE.TEXT" class="h5 darkblue regular line-height-golden" else>
            </p>
            <template>
              <div v-if="item.PROPERTY_CODE_VALUE !== null">
                <p class="h5 darkblue regular line-height-golden">Rabatkode : <span class="secondarycolor">{{item.PROPERTY_CODE_VALUE}}</span>
                </p>
                <input type="hidden" id="couponCode" :value="couponCode">
                <button type="button" @click.stop.prevent="copyCouponCode" class="standard-button h5 regular p2 flex justify-center items-center gibson line-height-1 not-rounded border-none">
                  <span>Kopier kode</span>
                  <span class="ml1"><i class="el-icon-copy-document"></i></span>
                </button>
              </div>
             <div v-else-if="item.PROPERTY_CONTACT_MEMBERS_CODE_VALUE === 'flugger101' ">

                      <p class="darkblue h3" >Kontakt</p>

                      <div class="flex px0 mt2"> <img :src="item.PROPERTY_CONTACT_PHOTO_VALUE" width="100" alt="">
                      <div class="" >
                       <p class="darkblue h6 regular pl2" >{{ item.PROPERTY_CONTACT_NAME_VALUE }}</p>
                        <div class="flex ">
                       <p class="darkblue h6 regular pl2" >Tel: {{ item.PROPERTY_CONTACT_PHONE_VALUE }}</p><a class="right pl1" style=""  :href="'skype:'+item.PROPERTY_CONTACT_PHONE_VALUE+'?call'" ><i class="right green el-icon-phone-outline"  style="font-size: 1.5em;"></i></a>
                          </div>
                       <p class="darkblue h6 regular pl2" >{{ item.PROPERTY_CONTACT_EMAIL_VALUE }}</p>
                       </div>
                       </div>
                    </div>
                  <div v-else></div>
              </template>
          </div>
          <a :href="item.PROPERTY_LINK_VALUE" target="_blank" class="action-button p2 flex justify-center items-center h4 m0 line-height-1 gibson not-rounded border-none" v-if="item.PROPERTY_CONTACT_MEMBERS_CODE_VALUE !== 'flugger101'">
            <span v-html="item.PROPERTY_BUTTON_VALUE" class="mr2 regular"></span><span><i class="el-icon-right"></i></span>
          </a>
        </div>
        <div class="py4"></div>
      </div>
    </div>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>

<script>
import fileUploadInput from '../../components/file-upload-input'
import Simplert from 'vue2-simplert'
export default {
  name: '',
  components: {
    fileUploadInput,
    Simplert
  },
  data () {
    return {
      insideLoading: true,
      hotlineLoading: false,
      haaId: '',
      salesPerson: '',
      couponCode: 'prohv21',
      medlemsfordele: [],
      formLegalTopicVisible: false,
      legalTopic: [],
      legalTopicData: [],
      note: '',
      fileList: [],
      nps: ''
    }
  },
  methods: {
    recommend () {
      this.$router.push('/recommend')
    },
    copyCouponCode () {
      let couponCodeToCopy = document.querySelector('#couponCode')
      couponCodeToCopy.setAttribute('type', 'text')
      couponCodeToCopy.select()

      try {
        /* var successful = document.execCommand('copy')
        var msg = successful ? 'successful' : 'unsuccessful'
        console.log(msg) */
        alert('Rabatkoden er nu kopieret')
      } catch (err) {
        alert('Oops, unable to copy')
      }
      couponCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    checkPermission () {
      var data = {
        operation: 'service_legal_permission',
        salesPerson: this.salesPerson,
        type: 'POST',
        levid: this.haaId
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.getLegalTopics()
            this.formLegalTopicVisible = true
          }
        },
        (err) => {
          console.log(err)
        }
      )
    },
    getLegalTopics () {
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'bitrix/getAllLegalTopic'
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.legalTopicData = res.data
          }
        },
        (err) => {
          console.log(err)
        }
      )
    },
    handleFileUpload (file) {
      this.fileList = file
    },
    submitLegalHotline () {
      var topic = this.legalTopic
      var note = this.note
      var fileList = this.fileList
      var uploadFinish = localStorage.getItem('uploadFinish')
      if (uploadFinish === true || uploadFinish === null) {
        if (topic.length > 0 && note !== '') {
          var files = []
          if (fileList.length > 0) {
            for (var i = 0; i < fileList.length; i++) {
              var file = fileList[i]
              files.push('https://www.kundematch.dk/HenttilbudImg.php?img=' + file)
            }
          }
          var data = {
            operation: 'bitrixApi',
            salesPerson: this.salesPerson,
            type: 'POST',
            url: 'bitrix/sendEmailLegalTopic',
            parameters: JSON.stringify({
              levid: this.haaId,
              value: topic,
              info: note,
              file: files
            })
          }
          this.$http.post('', data, { emulateJSON: true }).then(
            (response) => {
              var res = response.body
              if (res.success) {
                this.hotlineLoading = false
                this.legalTopic = null
                this.note = ''
                this.fileList = []
                let obj = {
                  title: 'Sendt!',
                  message: '',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
              }
            },
            (err) => {
              console.log(err)
            }
          )
          this.hotlineLoading = true
        } else {
          this.$toastr('error', 'Felter påkrævet')
        }
      } else {
        this.$toastr('error', 'Uploader stadig')
      }
    },
    getNPS () {
      var data = {operation: 'newsFeed', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, {emulateJSON: true})
        .then(
          response => {
            var res = response.body
            this.nps = parseInt(res.nps)
            // console.log('ddd' + this.nps)
          },
          response => {
            alert('error')
          }
        )
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
  },
  mounted () {
    this.show = true
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    var zip = localStorage.getItem('CompanyZip')
    var data = {
      operation: 'bitrixApi',
      salesPerson: this.salesPerson,
      type: 'GET',
      url: 'bitrix/getMembers?zip=' + zip
    }
    this.$http.post('', data, { emulateJSON: true })
      .then(
        response => {
          var res = response.body
          var medlemedata = res.data
          this.show = false
          if (res.login === false) {
            this.$router.push('/login')
          }
          medlemedata = medlemedata.filter((a) => {
            return a.ID !== '124'
          })
          this.medlemsfordele = medlemedata
          this.insideLoading = false
          // console.log(this.medlemsfordele)
        },
        response => {
          alert('error')
        }
      )
    this.checkPermission()
    this.getNPS()
  }
}
</script>

<style>
#medlemsfordele .el-select {
  padding: 2px 0;
  border: 1px solid #d1d4d7;
}
#medlemsfordele .el-select__tags {
  padding: 0 10px;
}
#medlemsfordele .el-select .el-tag {
  font-size: 15px;
  color: #fff;
  background-color: #19a3c0;
  margin: 1px 5px;
}
#medlemsfordele .el-tag.el-tag--info .el-tag__close {
  color: #fff;
  background-color: transparent;
  font-size: 15px;
  right: -5px;
  top: 1px;
}
#medlemsfordele .el-select input.el-input__inner {
  font-size: 1rem;
  border: none;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: #19a3c0;
}
.loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// medlemsfordele.vue?1ebc0327